'use es6';

import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import { loadVidyardApi } from 'ui-addon-video-player/utils/loadPlayerApi';
var ONPLAY_TIMEOUT = 100; // Exported for tests only

export var globals = {
  apiLoaded: null,
  instances: [],
  // Array of { container (element), destroy (function) }
  subscribers: []
};

var loadApi = function loadApi() {
  globals.apiLoaded = globals.apiLoaded || new Promise(function (resolve) {
    loadVidyardApi(function () {
      var vyApi = window.vidyardEmbed.api;
      vyApi.addReadyListener(function (_, player) {
        globals.subscribers.forEach(function (handler) {
          return handler(player);
        });
      });
      resolve(vyApi);
    });
  });
  return globals.apiLoaded;
};

var handlerWrappers = {
  // Debounce vidyard's duplicate play event -
  // happens twice when video is first played
  play: function play(listener) {
    var lastCalled = 0;
    return function () {
      if (Date.now() - lastCalled > ONPLAY_TIMEOUT) {
        lastCalled = Date.now();
        listener.apply(void 0, arguments);
      }
    };
  }
};

var prepareContainer = function prepareContainer(el) {
  if (!(el instanceof window.Element)) {
    throw new Error('video container must be a DOM element');
  }

  if (el.childNodes.length) {
    console.warn('video container was not empty. emptying...');

    while (el.lastChild) {
      el.removeChild(el.lastChild);
    }
  }
};

var deleteProperties = function deleteProperties(obj) {
  for (var _i = 0, _Object$keys = Object.keys(obj); _i < _Object$keys.length; _i++) {
    var key = _Object$keys[_i];
    delete obj[key];
  }
};

var filterArrayInPlace = function filterArrayInPlace(arr, condition) {
  arr.splice.apply(arr, [0, arr.length].concat(_toConsumableArray(arr.filter(condition))));
};

var vidyardApiFacade = function vidyardApiFacade(opts) {
  var listeners = {};
  var container = opts.container,
      uuid = opts.uuid;
  var resolve;
  var player;
  var vyApi; // Destroy any previously created player with the same container

  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = globals.instances[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var inst = _step.value;

      if (container === inst.container) {
        inst.destroy();
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return != null) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  prepareContainer(container);

  var readyHandler = function readyHandler(player_) {
    if (resolve && container.contains(player_.container) && player_.uuid === uuid) {
      resolve(player_);
    }
  };

  var ready = new Promise(function (resolve_) {
    resolve = resolve_;
    loadApi().then(function (vyApi_) {
      if (resolve) {
        vyApi = vyApi_; // Subscribe to global readyListener and render

        globals.subscribers.push(readyHandler);
        vyApi.renderPlayer(opts);
      }
    });
  });

  var destroy = function destroy() {
    if (!resolve) {
      if (player && vyApi) {
        vyApi.destroyPlayer(player);
      }

      player = null;
      vyApi = null;
      deleteProperties(listeners);
      filterArrayInPlace(globals.instances, function (inst) {
        return inst.destroy !== destroy;
      });
    } else {
      // Cancel eventual setup
      ready.then(destroy);
      resolve();
    }
  };

  var bind = function bind(event, listener) {
    if (typeof event !== 'string') {
      throw new Error("First argument to bind must be a string");
    }

    if (typeof listener !== 'function') {
      throw new Error("Second argument to bind must be a function");
    }

    if (!listeners[event]) {
      listeners[event] = handlerWrappers[event] ? handlerWrappers[event](listener) : listener;
      player.on(event, function () {
        if (listeners[event]) {
          listeners[event].apply(listeners, arguments);
        }
      });
    } else {
      throw new Error("Listener already defined for " + event + " on player " + uuid);
    }
  };

  var wrapMethod = function wrapMethod(name) {
    return function () {
      var _player;

      return player && (_player = player)[name].apply(_player, arguments);
    };
  };

  var unsubscribe = function unsubscribe() {
    // Remove readyHandler subscription, if present
    var subIndex = globals.subscribers.indexOf(readyHandler);

    if (subIndex > -1) {
      globals.subscribers.splice(subIndex, 1);
    }
  };

  ready.then(function (player_) {
    unsubscribe();

    if (player_) {
      globals.instances.push({
        container: container,
        destroy: destroy
      });
      player = player_;
    }

    resolve = null;
  });
  return {
    bind: bind,
    destroy: destroy,
    onReady: function onReady(fn) {
      return ready.then(function () {
        return player && fn();
      });
    },
    setPlaybackSpeed: wrapMethod('setPlaybackSpeed'),
    enableCaption: wrapMethod('enableCaption')
  };
};

export default vidyardApiFacade;